import type { FaireProductEntity } from "../../entity_types/product";

export const p_cga6jpy9d3: FaireProductEntity = {
  token: "p_cga6jpy9d3",
  type: "product",
  name: "Long Circle Color Block",
  brandToken: "b_3qsnmrjb8c",
  brandName: "Delaney and Blu",
  imageUrl:
    "https://cdn.faire.com/fastly/999e527f3639aa423c9cc32df295a0d59292828bc4c49c05bd15153263a7528f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/42fa594babededc194cd9df008ad599207bb1d4609dbb5df975214d46786c64b.jpeg",
    "https://cdn.faire.com/fastly/7edd991807f491c0eaa504fd76dd7ba0cf3386048615f8c5ada42107cafb3585.jpeg",
  ],
  priceDollars: 37.5,
  description:
    "Size: 5.25 in. long\n\nMade with nickel free posts and hypoallergenic metals.\n\nAll Delaney & Blu products are handmade with love in Cincinnati, Ohio. Each earring is a one of a kind item made specially for you. All of our items are lovingly rolled out, cut, baked, sanded and assembled by me, Delaney, owner and maker.\n\nPolymer clay is durable and lightweight, however it should be handled with care. We recommend not bending the clay, because although it is durable it can still break. They can also be scratched so be sure to keep them in a safe, dry place. It is not recommended to wear in water (showering or swimming). See our care instructions for further details.\n\nEach design is carefully thought out and made with love and carries with it, it's own, distinctive style. Due to the fact that all earrings are handmade in small batches, there may be small imperfections.  \n\n",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:46.915Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
